import {EAgentPaymentsTab} from 'src/containers/Agent';

export default {
  emptyReports: {
    subtitle: 'Пока у вас нет платящих клиентов',
    action: 'В список клиентов',
  },
  emptyDocuments: {
    title: 'Нет документов',
    subtitle: 'За отчетный период ни один документ не был сформирован',
  },
  allEmpty: {
    subtitle: 'Пока у вас нет платящих клиентов',
    action: 'В список клиентов',
  },
  tabs: {
    [EAgentPaymentsTab.REPORT]: 'Сводка',
    [EAgentPaymentsTab.DOCUMENTS]: 'Отчетные документы',
  },
  payments: {
    found: 'Платежей',
    search: 'быстрый поиск по клиенту',
    period: 'Выберите отчетный период',
    date: 'Дата оплаты',
    periodResult: 'Результат за период',
    commissionPercentage: 'Ваша агентская ставка',
    paymentsAmount: 'Сумма оплат в выбранном периоде',
    commissionAmount: 'Сумма комиссии за период',
    allPayments: 'Итого платежей',
    approximateAward: 'Предварительная сумма вознаграждения',
    awardHint: 'Точная сумма вознаграждения будет уточнена вашим менеджером',
    downloadReport: 'Выгрузить список',
    license: 'Лицензия {{name}}',
    whatsAppNumberConnection: 'Подключение номера телефона WhatsApp',
    th: {
      date: 'Дата оплаты',
      companyName: 'Название клиента',
      taxNumber: 'ИНН клиента',
      payment: 'Название платежа',
      amount: 'Сумма платежа без НДС',
      commission: 'Сумма вознаграждения',
    },
    quarter: 'Квартал',
  },
  documents: {
    info: 'В этот раздел загружаются итоговые отчеты за прошедший отчетный период. Вы можете создать на его основе акт-отчет: скачайте форму, дополните расчетом комиссии и указанием суммы вашего НДС.',
    th: {
      createdAt: 'Дата формирования',
      fileName: 'Название документа',
    },
    download: 'Скачать',
    name: 'Акт-отчет за период {{period}} {{year}}',
    noData: {
      title: 'Нет документов',
      subtitle: 'За отчетный период ни один документ не был сформирован',
    },
  },
};
